<template>
<div class="resources-container">
  <h6 class="related-resources-title">Related Resources</h6>

</div>

</template>

<script>

export default {
  name: "RelatedResources"


}
</script>

<style scoped>
.resources-container {
  background: #f6f6f6;
  height: 150px;
  padding: 10px 10px 10px 20px;
  width: 100%;
}

.related-resources-title {
  font-size: 18px;
  color: #2f3642;

}
</style>